import React from 'react';

export const laboralHiringColumns = () => {

  const hiringStateOptions = [ {value: 'active', label: I18n.t('laboral.hirings.index.tabs.active') }, { value: 'expired', label: I18n.t('laboral.hirings.index.tabs.expired')}]

  const tableColumnsDefault = [
    {
      field: 'company.name',
      header: I18n.t("activerecord.attributes.laboral/hiring.company"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre de la empresa',
        inputType: 'text',
        filterrific: {
          search: 'search_by_company_name'
        }
      },
    },
    {
      field: 'employee.identifier',
      header: I18n.t("activerecord.attributes.laboral/employee.identifier"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el identificador del empleado',
        inputType: 'text',
        filterrific: {
          search: 'search_by_employee_identifier'
        }
      },
    },
    {
      field: 'employee.name',
      header: I18n.t("activerecord.attributes.laboral/hiring.employee"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre del empleado',
        inputType: 'text',
        filterrific: {
          search: 'search_by_name'
        }
      },
    },
    {
      field: 'identifier',
      header: I18n.t("activerecord.attributes.laboral/hiring.identifier"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el identificador de la contratación',
        inputType: 'text',
        filterrific: {
          search: 'search_query'
        }
      },
    },
    {
      field: 'active_to_s',
      header: 'Estado de Contratación',
      filter: {
        enabled: true,
        placeholder: 'Seleccione un estado de contratación',
        inputType: 'simple_select',
        options: _.map(hiringStateOptions, hiringState => ({
          value: hiringState.value,
          label: hiringState.label,
        })),
        filterrific: {
          search: 'by_hiring_state'
        }
      },
    },
    {
      field: 'start_date_to_s',
      header: I18n.t("activerecord.attributes.laboral/hiring.start_date"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de inicio de la contratación',
        inputType: 'text',
        filterrific: {
          search: 'search_by_start_date'
        }
      },
    },
    {
      field: 'end_date_to_s',
      header: I18n.t("activerecord.attributes.laboral/hiring.end_date"),
      body: (row) => row?.end_date_to_s || 'Indefinido'
    },
  ]

  return tableColumnsDefault;
}

export const laboralEmployeeColumns = () => {

  const tableColumnsDefault = [
    {
      field: 'identifier',
      header: I18n.t("activerecord.attributes.laboral/employee.identifier"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el identificador del empleado',
        inputType: 'text',
        filterrific: {
          search: 'search_by_identifier'
        }
      },
    },
    {
      field: 'name',
      header: I18n.t("activerecord.attributes.laboral/employee.name"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre del empleado',
        inputType: 'text',
        filterrific: {
          search: 'search_by_employee_name'
        }
      }
    },
    {
      field: 'email',
      header: I18n.t("activerecord.attributes.laboral/employee.email"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el email del empleado',
        inputType: 'text',
        filterrific: {
          search: 'search_by_email'
        }
      },
    },
    {
      field: 'created_at',
      header: 'Fecha de creación',
      body: (row) => moment(row?.created_at).format('DD-MM-YYYY'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de creación',
        inputType: 'text',
        filterrific: { search: 'search_by_created_at' },
      }
    },
  ]

  return tableColumnsDefault;
}

export const abstractEntityColumns = () => {

  const tableColumnsDefault = [
    {
      field: 'name',
      header: 'Nombre del recurso',
      body: (row) => row?.name || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre del recurso',
        inputType: 'text',
        filterrific: { search: 'search_by_name' },
      },
    },
    {
      field: 'identifier',
      header: 'Identificador',
      body: (row) => row?.identifier,
      filter: {
        enabled: true,
        placeholder: 'Ingrese el identificador',
        inputType: 'text',
        filterrific: { search: 'search_query' },
      },
    },
    {
      field: 'created_at',
      header: 'Fecha de creación',
      body: (row) => moment(row?.created_at).format('DD-MM-YYYY'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de creación',
        inputType: 'text',
        filterrific: { search: 'search_by_created_at' },
      },
    },
  ];

  return tableColumnsDefault;
}

